import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { MarcheDTO } from '../model/marche/marche-dto';

@Injectable({
    providedIn: 'root'
  })
  export class MarcheService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAll() 
    {
        return this._restClientService.load<MarcheDTO[]>('marche/find-all');
    }
        
}      

    